import api from '@/store/api'
import lottie from 'lottie-web'
import robotWithCat from '@/assets/image/toeic/toeic_exam/RobotWithCat.json'
let loadingAnimation = null
var formal_examJs = {
  methods: {
    post_records_purchase (id, type) {
      let path = `/assessments/records/?purchase=no`

      return api.post(path, { id: id, type: type })
      .then((response) => {
        return response.data
      })
      .catch((err) => {
        return err.response.data
      })
    },
    post_assessments_records_start (item) {
      // 考試開始
      let self = this
      let path = `/assessments/records/?purchase=yes`
      self.$store.dispatch('isLoading', true)

      api.post(path, { id: item.id, type: item.type })
      .then((res) => {
        self.$store.dispatch('isLoading', false)
        self.$store.dispatch('getRemainPoints')
        // self.$router.push({ name: 'formal_exam', params: { select_id: item.id, practice_type: item.type }, query: { record_id: res.data.record_id } })
        self.$router.push({ name: this.returnRouter, params: { practice_type: item.type, exam_id: item.id }, query: { record_id: res.data.record_id } })
        // self.$router.push({ name: this.returnRouter, params: { params: { practice_type: item.type, exam_id: child2.id }, query: { record_id: res.data.record_id } })
      })
      .catch((err) => {
        self.$store.dispatch('isLoading', false)
        self.$swal.fire({
          focusConfirm: false,
          confirmButtonText: `確認`,
          title: 'Notice',
          text: err.response.data.msg || '發生錯誤',
          customClass: {
            title: 'text-white',
            container: '',
            popup: 'p-0',
            header: 'swal-header-notice justify-content-center align-items-center',
            closeButton: '',
            htmlContainer: 'font-semibold my-4 text-2xl',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      })
    },
    finish_error_swal () {
      this.$swal.fire({
        title: '作答提示',
        html: '<p>尚有句子未完成</p>',
        showCloseButton: false,
        showConfirmButton: false,
        focusConfirm: false,
        showDenyButton: false,
        customClass: {
          container: '',
          popup: 'p-0 max-w-xl w-100',
          header: 'py-2 text-white gept_main_bg',
          title: 'text-white m-0 text-2xl py-2',
          closeButton: 'top-0 right-0 position-absolute',
          htmlContainer: 'p-6 font-bold leading-loose text-center text-lg',
          actions: 'mb-4 mt-5',
          confirmButton: 'submitButton-gept',
          denyButton: 'denyButton-gept',
        }
      })
    },
    async post_assessments_records (exam_id, questionId, part, text, file) {
      const path = `/assessments/records/${exam_id}`;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('id', questionId);
      formData.append('part', part);
      formData.append('text', text || '');

      const config = {
        headers: { 'Content-Type': 'multipart/form-data', 'showLoading': false }
        // onUploadProgress: (progressEvent) => {
        //   const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //   console.log(`Upload progress: ${percent}%`);
        // }
      };

      // 定義一個函數執行上傳
      const tryPost = async () => {
        try {
          const response = await api.post(path, formData, config);
          console.log('Upload success:', response.data);
          return response.data;
        } catch (err) {
          console.error('Upload failed:', err);
          throw err;
        }
      };

      // 嘗試上傳一次，失敗再重試一次
      try {
        return await tryPost();
      } catch (firstErr) {
        console.warn('Retrying upload...');
        try {
          return await tryPost();
        } catch (secondErr) {
          console.error('Upload failed twice:', secondErr);
          return Promise.reject(secondErr);
        }
      }
    },

    post_gept_records_finish (exam_id) {
      this.showScoreCalculatingSwal()

      let attempt = 0
      const maxRetries = 20
      const retryInterval = 5000
      const path = `/assessments/records/${exam_id}/finish`
      const options = { headers: { showLoading: false } }

      this.$store.dispatch('isLoading', true)

      const makeRequest = () => {
        return api.post(path, options)
          .then(() => true)
          .catch(() => {
            attempt++
            if (attempt < maxRetries) {
              return new Promise(resolve => {
                setTimeout(() => resolve(makeRequest()), retryInterval)
              })
            } else {
              throw new Error('max retries reached')
            }
          })
      }

      makeRequest()
        .then(() => {
          const isQuiz = this.$route.path.includes('quiz')

          this.$router.push({
            name: isQuiz ? 'quiz_report_formal' : 'gept_report_formal',
            params: { record_id: exam_id }
          })
        })
        .catch(() => {
          this.$swal.fire({
            icon: 'error',
            title: '成績計算失敗',
            text: '請稍後再試或聯絡客服'
          })
        })
        .finally(() => {
          this.$store.dispatch('isLoading', false)
          this.closeScoreLoading()
        })
    },

    get_assessments_records (exam_id) {
      let path = `/api/toeic/exams/${exam_id}/records`

      return api.get(path)
      .then((res) => {
        return res
      })
      .catch(() => {
      })
    },

    post_gept_records_byFormal (exam_id, questionId, part, text, file) {
      let self = this
      let path = `assessments/records/${exam_id}`

      self.$store.dispatch('isLoading', true)

      let formData = new FormData()
      formData.append('file', file)
      formData.append('id', questionId)
      formData.append('part', part)
      formData.append('text', text)

      return api.post(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then((response) => {
        self.$store.dispatch('isLoading', false)
        return response.data
      })
      .catch((err) => {
        self.$store.dispatch('isLoading', false)

        return err.response
      })
    },

    checkSubmitReport (pName, pType) {
      let html
      html = `<p class="gept_main_color4 text-2xl mb-4">確認完成 ${pName} ${pType} 題型練習?</p>
      <p class="text-left mb-2">按下確認鍵後，請稍待片刻由AI英語小助教立即為您進行AI批改。</p>
      <p class="text-left mb-1">目前總點數 ${this.$store.state.remainPoints} 點</p>
      <p class="text-left mb-1">需扣除 10 點</p>
      <p class="text-left">扣除後點數 ${this.$store.state.remainPoints - 0}</p>`
      return this.$swal({
        html: html,
        showDenyButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        denyButtonText: `返回`,
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-4',
          header: 'p-0',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4 text-left',
          actions: 'mb-4 mt-2',
          confirmButton: 'submitButton-gept order-2',
          denyButton: 'denyButton-gept order_1'
        }
      })
        .then((result) => {
          if (result.isConfirmed === true) {
            return true
          } else {
            return false
          }
        }
      )
    },
    showScoreCalculatingSwal () {
      this.$swal.fire({
        html: `
          <div class="d-flex justify-content-center flex-column align-items-center">
            <div id="score-lottie" style="width:300px; margin-bottom:16px;"></div>
            <p style="font-size:1.5rem; font-weight:bold; text-align:center;">
              成績計算中......
            </p>
          </div>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: '#fff',
        customClass: {
          title: '',
          container: '',
          popup: 'p-5',
          header: '',
          closeButton: '',
          htmlContainer: '',
          actions: '',
          confirmButton: '',
          denyButton: ''
        },
        didOpen: () => {
          loadingAnimation = lottie.loadAnimation({
            container: document.getElementById('score-lottie'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: robotWithCat
          })
        },
        willClose: () => {
          if (loadingAnimation) {
            loadingAnimation.destroy()
            loadingAnimation = null
          }
        }
      })
    },
    closeScoreLoading () {
      this.$swal.close()
    }
  }
}

export default formal_examJs
